import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PaymentStateInfo } from '@cashier/cashier-model';

export interface PaymentInfoState {
  paymentInfo: PaymentStateInfo | null;
}

export const PAYMENTS_DATA_FEATURE_KEY = 'paymentInfo';

export const initialPaymentInfoState: PaymentInfoState = {
  paymentInfo: null,
};

export const paymentInfoSlice = createSlice({
  name: PAYMENTS_DATA_FEATURE_KEY,
  initialState: initialPaymentInfoState,
  reducers: {
    fetchPaymentInfoStart: (state, action: PayloadAction<string>) => undefined,
    fetchPaymentInfoSuccess: (
      state,
      action: PayloadAction<PaymentStateInfo>,
    ) => {
      state.paymentInfo = action.payload;
    },
    fetchPaymentInfoFailure: (state, action: PayloadAction<any>) => undefined,
    fetchPaymentCurrentStateStart: (
      state,
      { payload }: PayloadAction<string>,
    ) => undefined,
    fetchPaymentCurrentStateSuccess: (
      state,
      action: PayloadAction<PaymentStateInfo>,
    ) => {
      state.paymentInfo = action.payload;
    },
    toInitialPaymentInfoState: (state) => {
      state.paymentInfo = initialPaymentInfoState.paymentInfo;
    },
    initiateNewTransaction: () => undefined,
  },
});

export const paymentInfoReducer = paymentInfoSlice.reducer;

export const {
  fetchPaymentInfoStart,
  fetchPaymentInfoSuccess,
  fetchPaymentInfoFailure,
  fetchPaymentCurrentStateStart,
  fetchPaymentCurrentStateSuccess,
  toInitialPaymentInfoState,
  initiateNewTransaction,
} = paymentInfoSlice.actions;
